import { Flex } from '@chakra-ui/react';

const getStatusConfig = (status) => {
 const configs = {
  'não enviado': {
   bg: '#E5E5E5',
   color: '#5C6066',
   variant: 'colorNone',
  },
  'em avaliação': {
   bg: '#FDEEEA',
   color: '#EA582B',
   variant: 'warning',
  },
  aguardando: {
   bg: '#FFE9DD',
   color: '#FF9052',
   variant: 'warning',
  },
  'aguardando adequações': {
   bg: '#FFE9DD',
   color: '#FF9052',
   variant: 'warning',
  },
  enviado: {
   bg: '#E5F1F8',
   color: '#0073BB',
   variant: 'info',
  },
  'em revisão': {
   bg: '#FFF6E4',
   color: '#EAA72B',
   variant: 'warning',
  },
  avaliado: {
   bg: '#E9F8ED',
   color: '#21B84C',
   variant: 'success',
  },
  // Fluxo de auditoria (EG-22) — coexiste com os status legados acima.
  'em auditoria': {
   bg: '#FDEEEA',
   color: '#EA582B',
   variant: 'warning',
  },
  'em ajustes': {
   bg: '#FFE9DD',
   color: '#FF9052',
   variant: 'warning',
  },
  'em conferência final': {
   bg: '#FFF6E4',
   color: '#EAA72B',
   variant: 'warning',
  },
  auditado: {
   bg: '#E9F8ED',
   color: '#21B84C',
   variant: 'success',
  },
 };

 const normalizedStatus = (status || 'não enviado').toLowerCase();
 return configs[normalizedStatus] || configs['não enviado'];
};

const StatusTag = ({ status }) => {
 const statusConfig = getStatusConfig(status);
 const displayStatus = status
  ? status.charAt(0).toUpperCase() + status.slice(1).toLowerCase()
  : 'Não enviado';

 return (
  <Flex
   align='center'
   justify='center'
   px='12px'
   h='31px'
   bg={statusConfig.bg}
   color={statusConfig.color}
   borderRadius='4px'
   fontSize='13px'
   fontWeight='600'
   whiteSpace='nowrap'
  >
   {displayStatus}
  </Flex>
 );
};

export default StatusTag;
